export const lobbyConstants = {
  LOBBY_CREATE: 'LOBBY_CREATE',
  LOBBY_ADD_MEMBER: 'LOBBY_ADD_MEMBER',
  LOBBY_REMOVE_MEMBER: 'LOBBY_REMOVE_MEMBER',
  LOBBY_UPDATE_MEMBER: 'LOBBY_UPDATE_MEMBER',
};
